import { LoginService, type PasswordPolicyPublic } from "@common/client"
import { useSuspenseQuery } from "@tanstack/react-query"
import { makeNoArgsQuery, unwrap } from "./utils"

export const passwordPolicyKey = ["passwordPolicy"] as const

export const passwordPolicyQuery = makeNoArgsQuery({
  serviceCall: LoginService.getPasswordPolicy,
  queryKey: passwordPolicyKey,
})

export function usePasswordPolicy(): PasswordPolicyPublic {
  return useSuspenseQuery({
    queryKey: passwordPolicyKey,
    queryFn: () => LoginService.getPasswordPolicy().then(unwrap),
  }).data
}
